/**
 * This component is intended to reflect the high-level structure of your application
 * and render any components that are common across all views, such as the header or
 * top-level navigation. All other components should be rendered by route handlers.
 */

import React, { useEffect, useRef } from 'react';
import Header from './../components/Header';
import ScrollToTop from './../components/ScrollToTop';
import ErrorBoundary from './ErrorBoundary';
import { useConfig } from '@lore/config';
import IncompleteProfileBanner from './IncompleteProfileBanner';
import useRouter from '../hooks/useRouter';
import Navigation from './Navigation';
import useIntercom from '../hooks/useIntercom';
import { Outlet, useNavigate } from 'react-router-dom';
import ScrollAnchorContext from '../context/ScrollAnchorContext';

export default function Layout() {
  const { location } = useRouter();
  const config = useConfig();
  const scrollAnchorRef = useRef(null);
  const navigate = useNavigate();

  useIntercom();

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'F8') {
        e.preventDefault();
        const isOnFlagsPage = window.location.pathname === '/feature-flags';
        navigate(isOnFlagsPage ? -1 : '/feature-flags');
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  return (
    <ScrollAnchorContext.Provider value={scrollAnchorRef}>
      <div className="h-screen flex overflow-hiddenx bg-whitex">
        <div className="w-72 hidden lg:block z-10">
          <nav className="flex flex-col -mr-0.5 border-r-2 border-cs-gray-100 py-8 bg-white overflow-y-auto h-screen">
            <Navigation />
          </nav>
        </div>
        <div ref={scrollAnchorRef} className="flex-1 overflow-y-auto">
          <ScrollToTop key={`scroll-to-top-${location.pathname}`} />
          <IncompleteProfileBanner />
          <Header />
          <ErrorBoundary config={config}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </ScrollAnchorContext.Provider>
  );
};
